import { atom, selector, selectorFamily } from 'recoil'

export const safeAreaInsetState = atom({
    key: "safeAreaInsetState",
    default: {
        top: undefined,
        bottom: undefined,
        left: undefined,
        right: undefined
    }
})

export const userState = atom({
    key: "userState",
    default: undefined
})

export const systemState = atom({
	key: "systemState",
	default: {}
})

export const systemWebviewSelector = selector({
	key: "systemSelector",
	get: ({ get }) => {
		const system = get(systemState)
		return system.webview
	}
})

export const fromState = atom({
    key: "fromState",
    default: undefined
})

export const popupState = atom({
    key: "popupState",
    default: false
})